
import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { getStringDate } from 'src/app/common/util';
import { ConfigurationInvoice, InvoiceDataModel, InvoiceItemModel, InvoiceTemplateModel } from 'src/app/models/invoice-template.model';
import { ResponseObject } from 'src/app/models/response-object.model';
import { PriceClientResponse, SaleResponse } from 'src/app/models/sale.model';
import { CotService } from 'src/app/services/cot.service';
import { AuthenticationService } from '../../authentication/authentication/authentication.service';
import { SalesService } from 'src/app/services/sales.service';
import { QuotationResponse } from 'src/app/models/quotation.model';
import { WarehouseResponse } from 'src/app/models/warehouse.model';
import { InvoiceType } from 'src/app/enums/invoice-type.enum';
import { TemplateInvoice } from 'src/app/templateInvoice/templateInvoice';
import { ButtonLoading } from 'src/app/models/button-loading.model';
import { TokenAlphaService } from 'src/app/services/token-alpha.service';
import { CompanyService } from 'src/app/services/company.service';
import { InvoiceSaleService } from '../../inventory/sales/invoice-sale/invoice-sale.service';
import { concatMap, map } from 'rxjs/operators';
import { WarehouseService } from 'src/app/services/warehouse.service';
import { RolesAndPermissionsService } from 'src/app/services/roles-and-permissions.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-history-coti',
  templateUrl: './history-coti.component.html',
  styleUrls: ['./history-coti.component.scss']
})
export class HistoryCotiComponent implements OnInit {
  categorySelected = null;
  creating = false;
  editing = false;
  newQuotation: QuotationResponse = new QuotationResponse();
  cotizaciones: PriceClientResponse[] = [];
  cotizacionesFilter: PriceClientResponse[] = [];
  pagination = {
    total: [],
    filter: [],
    pageSize: 5,
    startElement: 0,
    lastElement: 0,
    pageIndex: 0
  }
  search = "";
  alwaysCreating = false;
  warehouseNames: { [key: number]: WarehouseResponse } = [];
  warehouseList: WarehouseResponse[] = [];
  warehouse = null;
  startDate = '';
  endDate = '';
  type = 0;
  invoiceCheck = true;
  receiptCheck = true;
  goodCheck = true;
  serviceCheck = true;
  isAscendent = 1;
  total = 0;
  loadingDownload: { [key: string]: boolean } = {};
  loadingCheckIn: { [key: string]: boolean } = {};
  deleting: { [key: string]: boolean } = {};
  detailing: { [key: string]: boolean } = {};
  invoiceDetail: any = null;
  waitingFor = null;
  seeingAnulate = false;
  anulating = false;
  todayDate = new Date();
  cancelledDescription = "";
  currentCompany = null;

  invoiceTemp = null;
  tokenButton = new ButtonLoading("btn-success", false, "VALIDAR", "fa-fingerprint");
  cashButton = new ButtonLoading("btn-success", false, "FACTURAR", "fa-file-invoice");
  token = null;
  checkTokenAlpha = true;
  cashiers = [];
  filterCashiers = [];
  selectedCashier: number | null = null;
  invoiceTempCash = null;

  cotizacionesOverDue: PriceClientResponse[] = [];
  quotationStatus: 'ACTIVE' | 'OVERDUE' = 'ACTIVE';

  constructor(
    private toastService: ToastrService,
    private cotService: CotService,
    private authService: AuthenticationService,
    private saleService: SalesService,
    private createService: TemplateInvoice,
    private tokenService: TokenAlphaService,
    private companyService: CompanyService,
    private invoiceSaleService: InvoiceSaleService,
    private warehouseService: WarehouseService,
    private roleService: RolesAndPermissionsService
  ) {
    const today = new Date();
    const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
    const lastDayOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);

    this.startDate = getStringDate(firstDayOfMonth);
    this.endDate = getStringDate(lastDayOfMonth);
    this.currentCompany = JSON.parse(authService.getCurrentCompany());
  }


  convertToString(date: number) {
    if (!date) {
      return '';
    }
    var tempDate = new Date(date);
    return getStringDate(tempDate);
  }


  ngOnInit(): void {
    this.loadWarehousesWithPermissions().subscribe({
      next: () => {
        this.getCotizaciones();
      },
      error: () => {
        this.toastService.error("Error al cargar bodegas");
      }
    });
    this.getCheckTokenAlpha();
    this.getCashsAcc();
  }

  getCashsAcc() {
    const currentUserPosition = this.authService.getUserPosition();
    this.invoiceSaleService.getCash().subscribe({
      next: (response: ResponseObject) => {
        this.cashiers = Object(response)['data'];
        console.log("Las cajas son");
        console.log(currentUserPosition);
        if (currentUserPosition) {
          const unique = new Set<number>();
          currentUserPosition.forEach((elemento) => {
            unique.add(elemento.cash);
          });
          const filter = Array.from(unique);
          this.cashiers = this.cashiers.filter(cash => filter.includes(cash.id));
          this.filterCashiers = this.cashiers;
          if (this.cashiers.length === 1) {
            this.selectedCashier = this.cashiers[0].id;
          }
        }else{
          this.filterCashiers = this.cashiers;
        }
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error("Error al obtener configuracion de las cajas");
      }
    });
  }

  getCheckTokenAlpha(){
    this.companyService.checkCompanyConfigTokenAlpha().subscribe(
      {
        next: (response: ResponseObject) => {
          this.checkTokenAlpha = response.data;
        },
        error: (error: HttpErrorResponse) => {
          this.toastService.error("Error al obtener configuracion de token");
        }
      }
    );
  }

  getCotizaciones() {
    this.cotService.getCotizaciones().subscribe(
      {
        next: (response: ResponseObject) => {
          this.cotizaciones = response.data;
          if (this.isAscendent == 1) {
            this.cotizaciones.reverse();
          }
          this.updateFilter();
        },
        error: (error: HttpErrorResponse) => {
          this.toastService.error("Error al obtener las cotizaciones");
        }
      }
    );
  }

  getOverdueCotizaciones() {
    this.cotService.getOverdueCotizaciones(this.startDate, this.endDate).subscribe({
      next: (response: ResponseObject) => {
        this.cotizacionesOverDue = response.data;

        if (this.isAscendent == 1) {
          this.cotizacionesOverDue.reverse();
        }

        this.applyFilters();
      },
      error: () => {
        this.toastService.error("Error al obtener las cotizaciones vencidas");
      }
    });
  }

  changeQuotationStatus() {
    this.waitingFor = null;

    if (this.quotationStatus === 'ACTIVE') {
      this.getCotizaciones();
    } else {
      this.getOverdueCotizaciones();
    }
  }

  filterCotizaciones() {
    console.log("Bodegas traidas", this.warehouseNames);

    const allowedWarehouseIds = Object.keys(this.warehouseNames).map(id => +id);

    const source = this.quotationStatus === 'ACTIVE'
      ? this.cotizaciones
      : this.cotizacionesOverDue;

    this.cotizacionesFilter = source.filter(cotizacion => {

      const warehouseId = +cotizacion.warehouse;

      if (!allowedWarehouseIds.includes(warehouseId)) {
        return false;
      }

      if (this.warehouse !== null && warehouseId !== +this.warehouse) {
        return false;
      }

      if (cotizacion.creationDate) {

        const creationDate = new Date(cotizacion.creationDate);
        creationDate.setHours(0, 0, 0, 0);

        if (this.startDate) {
          const start = new Date(this.startDate);
          start.setHours(0, 0, 0, 0);

          if (creationDate < start) {
            return false;
          }
        }

        if (this.endDate) {
          const end = new Date(this.endDate);
          end.setHours(23, 59, 59, 999);
          end.setHours(end.getHours() + 6);

          if (creationDate > end) {
            return false;
          }
        }
      }

      return true;
    });
  }

  loadWarehousesWithPermissions(): Observable<void> {
    return this.warehouseService.getWarehouseByClue("").pipe(
      concatMap((response: ResponseObject) => {
        this.warehouseList = response.data.filter((w) => w != null);
        this.warehouseNames = {};
        this.warehouseList.forEach((w) => {
          this.warehouseNames[w.id] = w;
        });

        const idUser = JSON.parse(this.authService.getCurrentUser()).id;
        return this.roleService.getUserPosition(idUser);
      }),
      map((response: ResponseObject) => {
        const userPosition = response.data as any[];
        if (userPosition.length > 0) {
          const permissionWarehouse = userPosition
            .map(p => p.warehouse)
            .filter(w => w != null);

          this.warehouseList = this.warehouseList.filter(w => permissionWarehouse.includes(w.id));
          this.warehouseNames = {};
          this.warehouseList.forEach(w => this.warehouseNames[w.id] = w);
        }
      })
    );
  }



  getQuotationPDF(quotation: SaleResponse) {
    this.loadingDownload[quotation.id] = true;
    var selected = this.warehouseList.find((w) => {
      return w.id == quotation.warehouse
    });
    this.saleService.getDetailInvoiceCot(quotation).subscribe({
      next: (response: ResponseObject) => {
        console.log(response.data);
        this.loadingDownload[quotation.id] = false;
        quotation.detail = response.data;
        var invoiceDataNew = this.getQuotationData(quotation, selected);
        var configurationInvoice = new ConfigurationInvoice(selected['nfact'], selected['fcolor'], selected['scolor'], selected['tcolor'], selected['slogan']);
        this.createService.selectTemplate(configurationInvoice, invoiceDataNew, null);
      },
      error: (error: HttpErrorResponse) => {
        this.loadingDownload[quotation.id] = false;
        this.toastService.error("Error al obtener las cotizaciones");
      }
    })
  }

  getQuotationData(quotation: SaleResponse, warehouse) {
    var invoiceData = new InvoiceTemplateModel();
    invoiceData.type = InvoiceType.QUOTATION;
    invoiceData.warehouse = warehouse;
    invoiceData.certifier.data = "";
    invoiceData.certifier.date = "";
    invoiceData.certifier.nit = "";
    invoiceData.certifier.signature = "";
    invoiceData.client.name = quotation.name;
    invoiceData.client.nit = quotation.nit;
    invoiceData.invoice.date = quotation.creationDate ? new Date(quotation.creationDate).toISOString().split("T")[0] : "";
    invoiceData.invoice.number = quotation.id + "";
    invoiceData.invoice.serial = "";
    invoiceData.phrase = "";
    invoiceData.seller.city = "";
    invoiceData.seller.name = this.currentCompany.companyName;
    invoiceData.seller.nit = this.currentCompany.companyNIT + "";
    invoiceData.seller.state = "";
    invoiceData.seller.street = "";
    var total = 0;
    quotation.detail.forEach(bd => {
      total = total + (bd.quantity * bd.price);
      invoiceData.items.push(new InvoiceItemModel(bd.quantity, bd.price, bd.descriptionProduct));
    });
    invoiceData.total = total;
    return invoiceData;
  }

  resetDeletingDiv() {
    this.waitingFor = null;
  }


  factCot(x: any) {
    if (this.loadingCheckIn[x.id]) {
      return;
    }
    if (this.checkTokenAlpha) {
			this.showTokenAuthorization(x);
		} else {
			this.sendFactCot(x);
		}
  }

  factCotCash(x: any) {
    if (this.loadingCheckIn[x.id]) {
      return;
    }
    this.showCashModal(x);
  }

  showCashModal(x: any) {
		this.invoiceTempCash = x;
	}

  hideCashModal() {
		this.invoiceTempCash = null;
	}

  sendFactCot(x: any){
    //que aparezca lo mismo que el historial de factura
    // this.cotService.factCot(x.id) 
    //el servicio para facturar esta en cot.service.ts
    this.loadingCheckIn[x.id] = true;
    this.waitingFor = null;
    this.invoiceTemp = null;
    this.cotService.factCot(x.id).subscribe({
      next: (response: ResponseObject) => {
        this.toastService.success("Se ha facturado la cotizacion!");
        this.loadingCheckIn = {}
        this.getCotizaciones();
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
        this.loadingCheckIn = {}
      }
    });
  }

  sendFactCotCash(x: any){
    this.loadingCheckIn[x.id] = true;
    this.waitingFor = null;
    this.invoiceTempCash = null;
    this.cotService.factCotCash(x.id,this.selectedCashier).subscribe({
      next: (response: ResponseObject) => {
        this.toastService.success("Se ha facturado la cotizacion con caja!");
        this.loadingCheckIn = {}
        this.getCotizaciones();
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
        this.loadingCheckIn = {}
      }
    });
  }

  filtering() {
    this.pagination.total = this.pagination.total.filter((quotation) => {
      if (this.warehouse !== null) {
        if (this.warehouse != quotation.warehouse) {
          return false;
        }
      }
      return true;
    });
    this.total = 0;
    this.pagination.total.forEach((sale) => {
      this.total += (sale.totalCost);
    });
  }

  updateFilter() {
    this.applyFilters();
  }

  applyFilters() {
    this.filterCotizaciones();
    this.pagination.total = this.cotizacionesFilter;
    this.searching();
    this.filtering();
    this.resetPagination();
  }

  deleteCot(x: any) {
    this.waitingFor = x;
  }

  confirmDelete(invoice: any) {
    if (this.deleting[invoice.id]) {
      return;
    }
    this.deleting[invoice.id] = true;
    this.waitingFor = null;
    this.cotService.deleteCot(invoice.id).subscribe({
      next: (response: ResponseObject) => {
        this.toastService.success("Se ha eliminado la cotizacion!");
        this.deleting = {}
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error("Error al eliminar");
        this.deleting = {}
      }
    });
  }



  changeOrder() {
    this.pagination.total.reverse();
  }

  resetPagination() {
    this.pagination.filter = this.pagination.total.slice(0, this.pagination.pageSize);
    this.pagination.pageIndex = 0;
    this.pagination.lastElement = this.pagination.filter.length;
    this.pagination.startElement = 0;
  }

  searching() {
    this.pagination.total = this.pagination.total.filter((sale) => {
      return sale.id + '' == this.search || sale.nit.toLowerCase().includes(this.search.toLowerCase()) || sale.name.toLowerCase().includes(this.search.toLowerCase())
    });
    this.pagination.pageIndex = 0;
    this.pagination.startElement = 0;
    this.pagination.filter = this.pagination.total.slice(0, this.pagination.pageSize);
    this.pagination.lastElement = this.pagination.filter.length;
  }

  showTokenAuthorization(x: any) {
		this.invoiceTemp = x;
	}

  hideTokenAuthorization() {
		this.token = null;
		this.invoiceTemp = null;
	}

  validateToken() {
		if (this.tokenButton.loading) {
			return;
		}
		this.tokenButton.loading = true;
		this.tokenService.useToken(this.token).subscribe({
			next: (response: ResponseObject) => {
				this.tokenButton.loading = false;
				if (response.data) {
					this.token = null;
          this.sendFactCot(this.invoiceTemp);
				} else {
					this.toastService.error("El token no es válido. Contacta con el administrador o genera un nuevo.");
				}
			},
			error: (error) => {
				this.tokenButton.loading = false;
				this.toastService.error("Error al validar el token");
			}
		})
	}

  validateFactCotCash() {
		if (this.cashButton.loading) {
			return;
		}
    if(this.selectedCashier == null){
      this.toastService.error("Debes seleccionar una caja");
      return;
    }
		this.cashButton.loading = true;
    this.sendFactCotCash(this.invoiceTempCash);
    this.cashButton.loading = false;
	}

  changeDateFilter() {
    if (this.quotationStatus === 'OVERDUE') {
      this.getOverdueCotizaciones();
    } else {
      this.applyFilters();
    }
  }
}
